import React, { useRef, useEffect, useState } from 'react';
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { Input } from '@/components/ui/input';

export const AddressInput = ({
  value,
  onChange,
  placeholder = "Ingresa la dirección de entrega"
}) => {
  const inputRef = useRef(null);
  const [autocompleteInstance, setAutocompleteInstance] = useState(null);
  const places = useMapsLibrary('places');

  useEffect(() => {
    if (!places || !inputRef.current) return;

    try {
      const autocomplete = new places.Autocomplete(inputRef.current, {
        fields: ['geometry', 'formatted_address', 'name'],
        componentRestrictions: { country: 'mx' },
        types: ['geocode']
      });

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        
        if (place.geometry?.location) {
          onChange(place.formatted_address || '', {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          });
        }
      });

      setAutocompleteInstance(autocomplete);

      return () => {
        window.google.maps.event.clearInstanceListeners(autocomplete);
      };
    } catch (error) {
      console.error('Error initializing autocomplete:', error);
    }
  }, [places, onChange]);

  return (
    <Input
      ref={inputRef}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full"
    />
  );
};